import React from 'react';

export interface LocationProps {
  className?: string;
}

const Location: React.FC<LocationProps> = ({ className }) => {
  return (
    <svg viewBox="0 0 16 18" fill="none" className={className}>
      <path
        clipRule="evenodd"
        d="m8 14.7305 3.7287-3.7287c2.0593-2.05928 2.0593-5.39805 0-7.45734-1.0301-1.03003-2.37609-1.54446-3.7287-1.54446s-2.69863.51443-3.72867 1.54446c-2.05928 2.05929-2.05928 5.39806 0 7.45734zm0 2.8284-5.14288-5.1429c-2.8403358-2.84032-2.8403363-7.44541 0-10.28575 1.42017-1.420166 3.28152-2.13025 5.14288-2.13025s3.7227.710084 5.1429 2.13025c2.8403 2.84034 2.8403 7.44543 0 10.28575z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default Location;
